import { careerService } from './services';

export default {
  // get
  getAllGraduateInvitations: () => careerService().get('/graduate-invitations'),

  // post
  upsertBatchInvitations: (id, data) => careerService().post(`/graduate-invitations/${id}`, data),
};
